document.addEventListener("DOMContentLoaded", function(event) {
    function handler(entries) {
        entries.forEach(function(entry){
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
            }
        });
    }

    var animBoxes = document.querySelectorAll("[data-animation-el]");
    var observer = new IntersectionObserver(handler, {threshold: 0 });
    animBoxes.forEach(function (box) {
        observer.observe(box);
    });
});

